/* Bob Logistics Worldwide — category drawer (tab switching + positioning) */
(function () {
  function initDrawer(drawer) {
    if (!drawer || drawer.__ggInit) return;
    drawer.__ggInit = true;
    var tabs = Array.prototype.slice.call(drawer.querySelectorAll('.gcat__tab'));
    var views = Array.prototype.slice.call(drawer.querySelectorAll('.gcat__view'));

    function activate(index) {
      tabs.forEach(function (t) {
        var on = t.getAttribute('data-gcat-tab') === String(index);
        t.classList.toggle('is-active', on);
        t.setAttribute('aria-selected', on ? 'true' : 'false');
      });
      views.forEach(function (v) {
        v.classList.toggle('is-active', v.getAttribute('data-gcat-view') === String(index));
      });
    }

    tabs.forEach(function (tab) {
      var idx = tab.getAttribute('data-gcat-tab');
      tab.addEventListener('click', function (e) { e.preventDefault(); activate(idx); });
      tab.addEventListener('mouseenter', function () { activate(idx); });
    });
  }

  /* Position the panel directly under the header (handles announcement bar,
     sticky header height, and mobile's extra search row). */
  function positionDrawer() {
    var panel = document.querySelector('.menu-drawer--giftgo');
    if (!panel) return;
    var header = document.querySelector('.header-wrapper') || document.querySelector('.section-header');
    var bottom = header ? Math.round(header.getBoundingClientRect().bottom) : 120;
    if (bottom < 0) bottom = 0;
    document.documentElement.style.setProperty('--gg-drawer-top', bottom + 'px');
  }

  function ready() {
    var drawer = document.querySelector('.gcat');
    if (drawer) initDrawer(drawer);

    var details = document.getElementById('Details-menu-drawer-container');
    if (details) {
      // reposition whenever the drawer is toggled open
      details.addEventListener('toggle', function () {
        if (details.open) positionDrawer();
      });
      var summary = details.querySelector('summary');
      if (summary) summary.addEventListener('click', function () { requestAnimationFrame(positionDrawer); });
    }
    window.addEventListener('resize', positionDrawer, { passive: true });
    window.addEventListener('scroll', positionDrawer, { passive: true });
    positionDrawer();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', ready);
  } else {
    ready();
  }
})();
